import { type Meta } from '../types/docs';

const META: Meta = {
  description:
    'A user clicks Generate in the Translate wizard, capturing the protection and skip decisions made while reviewing the detected text zones',
  name: 'translation_protection_applied',
  params: [
    {
      description: 'How many protected areas the user drew on the image',
      name: 'protected_regions_drawn',
      required: true,
      type: 'number',
    },
    {
      description: 'Whether the user skipped at least one detected text zone with the Skip control',
      name: 'areas_skipped',
      required: true,
      type: 'boolean',
    },
    {
      description: 'Whether at least one detected text zone was left untranslated because a protected area covered it',
      name: 'areas_excluded_by_region',
      required: true,
      type: 'boolean',
    },
  ],
};

export default META;
